module.exports = __webpack_public_path__ + "img/zlindex9.6afc6d98.png";